
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rating/books/[pageNumber]",
      function () {
        return require("private-next-pages/rating/books/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rating/books/[pageNumber]"])
      });
    }
  